import { gql } from '@apollo/client';

const WORK_ORDER_FLAG_TEMPLATE_FIELDS = gql`
  fragment WorkOrderFlagTemplateFields on WorkOrderFlagTemplate {
    id
    flagValue
    iconName
    backgroundColor
    textColor
    isActive
    sortOrder
    createdAt
    updatedAt
  }
`;

export const CUSTOM_WORK_ORDER_FLAG_FIELDS = gql`
  fragment CustomWorkOrderFlagFields on CustomWorkOrderFlag {
    id
    workOrderId
    templateId
    template {
      ...WorkOrderFlagTemplateFields
    }
    flagType
    flagValue
    flagColor
    isManual
    addedByUserId
    addedByUser {
      id
      name
    }
    sortOrder
    createdAt
    updatedAt
  }
  ${WORK_ORDER_FLAG_TEMPLATE_FIELDS}
`;

export const GET_WORK_ORDER_FLAG_TEMPLATES = gql`
  query GetWorkOrderFlagTemplates {
    getWorkOrderFlagTemplates {
      ...WorkOrderFlagTemplateFields
    }
  }
  ${WORK_ORDER_FLAG_TEMPLATE_FIELDS}
`;

export const GET_ACTIVE_WORK_ORDER_FLAG_TEMPLATES = gql`
  query GetActiveWorkOrderFlagTemplates {
    getActiveWorkOrderFlagTemplates {
      ...WorkOrderFlagTemplateFields
    }
  }
  ${WORK_ORDER_FLAG_TEMPLATE_FIELDS}
`;

export const CREATE_WORK_ORDER_FLAG_TEMPLATE = gql`
  mutation CreateWorkOrderFlagTemplate($input: CreateWorkOrderFlagTemplateInput!) {
    createWorkOrderFlagTemplate(input: $input) {
      ...WorkOrderFlagTemplateFields
    }
  }
  ${WORK_ORDER_FLAG_TEMPLATE_FIELDS}
`;

export const UPDATE_WORK_ORDER_FLAG_TEMPLATE = gql`
  mutation UpdateWorkOrderFlagTemplate($input: UpdateWorkOrderFlagTemplateInput!) {
    updateWorkOrderFlagTemplate(input: $input) {
      ...WorkOrderFlagTemplateFields
    }
  }
  ${WORK_ORDER_FLAG_TEMPLATE_FIELDS}
`;

export const DELETE_WORK_ORDER_FLAG_TEMPLATE = gql`
  mutation DeleteWorkOrderFlagTemplate($input: DeleteWorkOrderFlagTemplateInput!) {
    deleteWorkOrderFlagTemplate(input: $input)
  }
`;

export const GET_CUSTOM_FLAGS_FOR_WORK_ORDER = gql`
  query GetCustomFlagsForWorkOrder($workOrderId: ID!) {
    getCustomFlagsForWorkOrder(workOrderId: $workOrderId) {
      ...CustomWorkOrderFlagFields
    }
  }
  ${CUSTOM_WORK_ORDER_FLAG_FIELDS}
`;

export const ADD_CUSTOM_WORK_ORDER_FLAG = gql`
  mutation AddCustomWorkOrderFlag($input: AddCustomWorkOrderFlagInput!) {
    addCustomWorkOrderFlag(input: $input) {
      ...CustomWorkOrderFlagFields
    }
  }
  ${CUSTOM_WORK_ORDER_FLAG_FIELDS}
`;

export const UPDATE_CUSTOM_WORK_ORDER_FLAG = gql`
  mutation UpdateCustomWorkOrderFlag($input: UpdateCustomWorkOrderFlagInput!) {
    updateCustomWorkOrderFlag(input: $input) {
      ...CustomWorkOrderFlagFields
    }
  }
  ${CUSTOM_WORK_ORDER_FLAG_FIELDS}
`;

export const REMOVE_CUSTOM_WORK_ORDER_FLAG = gql`
  mutation RemoveCustomWorkOrderFlag($input: RemoveCustomWorkOrderFlagInput!) {
    removeCustomWorkOrderFlag(input: $input)
  }
`;

export const BULK_UPDATE_CUSTOM_WORK_ORDER_FLAGS = gql`
  mutation BulkUpdateCustomWorkOrderFlags($input: BulkUpdateCustomWorkOrderFlagsInput!) {
    bulkUpdateCustomWorkOrderFlags(input: $input) {
      ...CustomWorkOrderFlagFields
    }
  }
  ${CUSTOM_WORK_ORDER_FLAG_FIELDS}
`;
